var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 151,
    viewBox: "0 0 156 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5553 130.638L28.6544 47.653L127.538 48.2559L77.5553 130.638Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.459 128.365L21.2193 71.2488L112.069 33.5483L100.459 128.365Z",
    fill: "#A39292"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2962 102.432L78.5266 20.1903L127.177 103.312L28.2962 102.432Z",
    fill: "#7DB1B5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_5_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4266 123.034L49.482 27.5577L135.091 75.3424L49.4266 123.034Z",
    fill: "#FFD29D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.183,
    height: 110.247,
    fill: "white",
    transform: "matrix(-0.999981 -0.00609745 0.00654054 -0.999979 134.646 130.986)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.578,
    height: 110.87,
    fill: "white",
    transform: "matrix(-0.92363 0.383284 -0.406663 -0.913578 152.911 106.598)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.213,
    height: 113.243,
    fill: "white",
    transform: "matrix(-0.505131 -0.863043 0.877828 -0.478976 56.3846 150.422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_5_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.21,
    height: 111.246,
    fill: "white",
    transform: "matrix(-0.873186 -0.487387 0.513697 -0.857972 98.8532 150.623)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIco);
export default __webpack_public_path__ + "static/media/menu_ico.8b25a437125b586d61e9d751230b435c.svg";
export { ForwardRef as ReactComponent };